import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Page, Header } from 'components'
import useRouter from 'utils/useRouter'
import clsx from 'clsx'

import { Formulario } from './components'
import { useParams } from 'react-router'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3, 3, 6, 3),
  },
  aboutProject: {
    marginTop: theme.spacing(3),
  },
}))

export const CancelarEncaminharVestigio = (props) => {
  const { route } = props
  const classes = useStyles()
  const router = useRouter()
  const params = useParams()

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} pathname={router.location.pathname} router={router} />
      <Formulario editar={route.editar} idVestigio={params.id} className={classes.aboutProject} />
    </Page>
  )
}
